import React from 'react';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import { states } from '@/constants/lifecycle';
import { firstError } from '@/utils/errors';
import TabActions from '@/components/tabs/TabActions';
import { validateRequestSection } from '../../helper';
import Selectors from '../hooks/selectors';
import Events from '../../hooks/events';

export const validateRequestWorkspaceStep = ({ request, requestNewWorkspaceForm }) => (
  validateRequestSection(request, requestNewWorkspaceForm, 'workspace')
);

const RequestWorkspaceActions = ({
  category,
  code,
  compact,
  goBack,
  goForward,
}) => {
  const {
    readErrors,
    requestNewWorkspaceReadStatus,
    saveStatus,
    sourceUrl,
  } = Selectors.useRequestWorkspaceActions({ category, code });
  const cancelRequest = Events.useDestroyRequests();

  return (
    <TabActions className="aridhia-request-access-wizard-actions">
      <CloseButton
        disabled={saveStatus === states.PENDING}
        onClick={() => cancelRequest({
          items: [{ code, isNew: true, steps: { sourceUrl } }],
          isArchival: false,
          silent: true,
        })}
      />
      <BackButton onClick={goBack} disabled={saveStatus === states.PENDING} iconOnly={compact} />
      <ForwardButton
        onClick={goForward}
        iconOnly={compact}
        disabled={requestNewWorkspaceReadStatus !== states.SUCCESS
          || saveStatus === states.PENDING
          || firstError(readErrors)}
      />
    </TabActions>
  );
};

export default RequestWorkspaceActions;
